const cleanFilename = (filename) => {
  filename = filename.trim()
  let tempFilename = filename.toLowerCase().replace(/[^a-z0-9\s-]+/g, '')
  filename = tempFilename.replace(/[\s-]+/g, '-')
  return filename
}

export default {
  generateFilename: (editedItem) => {
    if (editedItem.filename === '') {
      let filename = cleanFilename(editedItem.title)
      return filename
    } else {
      return editedItem.filename
    }
  },

  validateFilename: (filename) => {
    let tempFilename = cleanFilename(filename)
    return tempFilename
  },

  generatePassword: (passwordLength) => {
    // Check for valid password length
    if (passwordLength < 1) {
      passwordLength = 10
    }

    // List of different kinds of characters (small, upper, numbers and special chars)
    let alphabetList = 'abcdefghijkmnpqrstuvwxyz'
    let alphabetUpperList = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
    let numberList = '123456789'
    let specialCharList = '!@#^$%'

    // List of all characters together
    let allCharList = alphabetList + alphabetUpperList + numberList + specialCharList

    // Variable to store the newly generated password
    let randomPassword = []

    // Get one random characters from each kind of set (small, upper, numbers and special chars)
    randomPassword[0] = alphabetList.substr(Math.floor(Math.random() * alphabetList.length), 1)
    randomPassword[1] = alphabetUpperList.substr(Math.floor(Math.random() * alphabetUpperList.length), 1)
    randomPassword[2] = numberList.substr(Math.floor(Math.random() * numberList.length), 1)
    randomPassword[3] = specialCharList.substr(Math.floor(Math.random() * specialCharList.length), 1)

    // Fill the remaining password length with characters from the full set
    for (let i = randomPassword.length; i < passwordLength; i++) {
      randomPassword[i] = allCharList.substr(Math.floor(Math.random() * allCharList.length), 1)
    }

    // Shuffle the order of the characters
    let currentIndex = randomPassword.length
    let temporaryValue
    let randomIndex

    while (currentIndex > 0) {
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex -= 1
      temporaryValue = randomPassword[currentIndex]
      randomPassword[currentIndex] = randomPassword[randomIndex]
      randomPassword[randomIndex] = temporaryValue
    }

    return randomPassword.join('')
  }
}
